import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_ALLERGEN_IMAGE_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateAllergenImageDetailsArgs } from '../graphql/transformers'
import { UPDATE_ALLERGEN_IMAGE_DETAILS } from '../redux/action-types'

const useUpdateAllergenImageDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isImageDetailsLoading, imageDetailsError } = useSelector(
    store => store.allergens.allergen,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_ALLERGEN_IMAGE_DETAILS_MUTATION,
        { id, data: transformToUpdateAllergenImageDetailsArgs(data) },
        dispatch,
        UPDATE_ALLERGEN_IMAGE_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    { isLoading: isImageDetailsLoading, error: imageDetailsError },
  ]
}

export default useUpdateAllergenImageDetailsMutation
